import useApiMutation from 'shared/hooks/use-api-mutation';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import productsKeys from '../util/products-keys';
import {ProductProps} from '../types';

const useEditWorkingPeriod = (id: string) => {
  const {setData} = useQueryHelpers();

  const onSuccess = (data: ProductProps) => {
    setData(productsKeys.details(id), data);
  };

  return useApiMutation({
    url: `/products/${id}/working-periods`,
    method: 'PATCH',
    errorTitle: 'Erro ao editar produto',
    successTitle: 'Editar produto',
    successMessage: 'Horário de funcionamento atualizado com sucesso',
    redirectUrl: `/menu/products/${id}/working-periods`,
    onSuccess,
  });
};

export default useEditWorkingPeriod;
